


















































import Vue from 'vue'
import HeaderSection from './HeaderSection.vue'
import FilterItem from './FilterItem.vue'

import { EditPattern } from '@/search/types'
export default Vue.extend({
  components: {
    HeaderSection,
    FilterItem
  },
  props: {
    editPatternList: {
      type: Array as () => EditPattern[],
      required: true
    },
    searchEditPatterns: {
      type: Array as () => string[],
      required: true
    }
  },
  data(): {
    toggleSection: boolean
    selectedEditPatterns: string[]
  } {
    return {
      toggleSection: true,
      selectedEditPatterns: [...this.searchEditPatterns]
    }
  },
  watch: {
    searchEditPatterns(newVal: string[]) {
      this.selectedEditPatterns = newVal
    }
  },
  methods: {
    toggleSectionHandler(value: { [key: string]: boolean }) {
      this.toggleSection = value.toggle
    },
    onChangeSelectedEditPatterns() {
      this.$emit('onUpdateSelectedEditPattern', this.selectedEditPatterns)
    }
  }
})
